import type { CreateShopLocationDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useAddLocation(shop: { id: string }) {
	return useApiMutation("post", "/shops/{shopId}/locations", {
		invalidate: useInvalidateShop(shop.id),
		mapVariables: (requestBody: CreateShopLocationDto) => ({
			params: { path: { shopId: shop.id } },
			body: requestBody,
		}),
	});
}
